import { render, staticRenderFns } from "./reschedule.vue?vue&type=template&id=70a52115&scoped=true&"
import script from "./reschedule.vue?vue&type=script&lang=js&"
export * from "./reschedule.vue?vue&type=script&lang=js&"
import style0 from "./reschedule.vue?vue&type=style&index=0&id=70a52115&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a52115",
  null
  
)

export default component.exports